import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@/auth/AuthContext';
import { queryClient } from '@/lib/queryClient';
import { router } from '@/router';
import { runtimeHandsFreeEnabled } from '@/voice/wake/handsFreeConfig.ts';
import './index.css';

// STARTUP: persist the ?handsfree= opt-in to localStorage BEFORE the router mounts
// or any auth/route redirect can drop the query string (proven mechanism: the
// lazy popup-open read races ProtectedRoute's pathname-only bounce). Reads
// window.location.search + writes localStorage; pure no-op without the param.
// Hands-free only; import is engine-free (handsFreeConfig is a pure config module).
runtimeHandsFreeEnabled();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
);
